// src/graphql/queries/userQueries.js
export const GET_SCREEN_INFO = `
query{
    screens{
	    activeCategory
	    activeSubCategory
	    merchantJourneyType
	    screens
      }
    }
`;

export const GET_USER_NAME = `query{
 userName{
      firstName
      lastName
  }
}`;
export const GET_USER_PHONE = `query{
    userPhone{
        phone
        resendReadyTime
    }
}`;
export const GET_ENTITY_ADDRESS = `query{
entityAddress{
        address{
            address
            state
            city
            pinCode
            type
            ckycVerified
        }
}}`;
export const GET_BRAND_NAME = `query MerchantBrandName {
    merchantBrandName {
        details {
            detailType
            data
        }
    }
}`;

export const GET_MERCHANT_USECASE = `query MerchantUseCase {
    merchantUseCase {
        details {
            detailType
            data
        }
    }
}`;
export const GET_PAN_NUMBER = `query EnterPAN($panType: String!) {
   enterPAN(panType : $panType) {
      PAN
      PANFor
      nameOnPAN
    }
  }`;
export const GET_PAN_DETAILS = `query VerifyPAN($panType: String!) {
    verifyPAN(panType: $panType) {
        PAN
        PANFor
        nameOnPAN
    }
}`;
export const SEARCH_CKYC = `query SearchIndividualCkyc {
  searchIndividualCkyc {
    requestId
    result {
      ckycNo
      name
      mobileNumber
    }
    kycData {
            ckycId
      maskedAadhaar
      name
      gender
      dob
      mobile
      email
      address
      generatedAt
      imageData {
        imageExtension
        imageType
        image
      }
    }
  }
}`;
export const GET_ENTITY_TYPE = `query EntityType {
    entityType {
        details {
            detailType
            data
        }
    }
}`;

export const GET_REVIEW_DETAILS = `query reviewDetails($panType: String!){
    userName{
        firstName
        lastName
    }
    entityAddress{
        address{
            address
            state
            city
            pinCode
            type
            ckycVerified
        }
    }
    userPhone{
        phone
    }
    verifyPAN(panType: $panType) {
        PAN
        PANFor
        nameOnPAN
    }
    merchantBrandName {
        details {
            detailType
            data
        }
    }
    merchantUseCase {
        details {
            detailType
            data
        }
    }
    entityType {
        details {
            detailType
            data
        }
    }
    monthlyBookSize {
        details {
            detailType
            data
        }
    }
    dateOfIncorporation {
        dateOfIncorporation
    }
}`;

export const GET_MONTHLY_BOOK_SIZE = `query MonthlyBookSize {
    monthlyBookSize {
        details {
            detailType
            data
        }
    }
}`;

export const GET_MERCHANT_DETAILS = `query GetMerchantDetails($detailTypes: [MerchantDetailType!]!) {
    merchantDetails(detailTypes: $detailTypes) {
        details {
            detailType
            data
            status
            makerName
            checkerName
        }
    }
}`;

// ------------------------------------------------------------
export const GET_ACCOUNT_DETAILS = `query{
    accountDetails {
        accountNo
        ifscCode
        accountHolderName
        verificationStatus
    }
}`;

export const GET_GST_DETAILS = `query {
    gstDetails {
      gstNo
      cin
      donotHaveGstDetails
    }
}`;

export const GET_DATE_OF_INCORPORATION = `query GetDateOfIncorporation {
    dateOfIncorporation {
        dateOfIncorporation
    }
}`;

export const GET_MERCHANT_CATEGORIES = `query{
    categories{
        categoryName
        info{
            id
            name
        }
    }
}`;

export const GET_ID_PROOF = `query {
  idProof {
    masterDocTypeId
    docRelationType
    docRelationTypeId
    filePath
  }
}
`;

export const GET_MASTER_DOCS = `query{
    masterDocs{
        id
        supportedFiles
        docType
    }
}
  `;

export const GET_FILE_NAME = `query IdProofQuery($idProof: [Int]!) {
    idProof(idProof: $idProof) {
        masterDocTypeId
        filePath
        docType
    }
}
  `;
export const GET_SEL_MERCHANT_CATEGORIES = `query BusinessCategory {
    businessCategory {
        details {
            detailType
            data
        }
    }
}`;

const hardcodedIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const GET_KYC_REVIEW_DETAILS = `query($panType: String!){
    accountDetails {
        accountNo
        ifscCode
        accountHolderName
        verificationStatus
    }
    gstDetails {
        gstNo
        cin
        donotHaveGstDetails
    }
    businessCategory {
        details {
            detailType
            data
        }
    }
    idProof(idProof: [${hardcodedIds.join(',')}]) {
        masterDocTypeId
        filePath
        docType
        source
    }
    verifyPAN(panType: $panType) {
        PAN
        PANFor
        nameOnPAN
    }
}`;
